import Network from 'infrastructure/js/modules/network';
import * as externalNotificationService from '../../../services/Notifications/externalNotificationService';
import {api as messageDialogApi} from '../../MessageDialog/messageDialogActions';
import { api as gridApi} from './externalNotificationsGridActions';
import {createLabelHelper} from 'infrastructure/js/utils/labelHelper';


/////////////////////////////////////////
// ACTION TYPES - PUBLIC, FOR REDUCERS
export const actionTypes = {
};

////////////////////////////////////////////////////////////////
// PLAIN ACTION CREATORS - PRIVATE, FOR LOCAL DISPATCH ONLY
const actions = {
};

/////////////////////////////////////////////////////
// METHODS FOR JSX PROPS - PUBLIC, ALL THUNK TYPE
export let jsxActions = {};

jsxActions.reload = function () {
  return function (dispatch, getState) {
    gridApi.reload(dispatch, getState)();
  }
};

jsxActions.clearFilters = function () {
  return function (dispatch, getState) {
    gridApi.clearFilters(dispatch, getState)();
  }
};

jsxActions.removeExternalNotificationSettings = function(data) {
  return function(dispatch, getState) {
    api.removeExternalNotificationSettings(dispatch, getState)(data);
  }
};

/////////////////////////////////////////////////////////////////////////
// API METHODS - PUBLIC, FOR OTHER ACTION MODULES (and internal use)
export let api = {};

api.activate = function (dispatch, getState) {
  return function (items) {
    let ids = items.map((item) => item.id);
    externalNotificationService.activateExternalNotifications(ids).then(()=>{

      gridApi.reload(dispatch, getState)();
    });
  }
};

api.deactivate = function (dispatch, getState) {
  return function (items) {
    let ids = items.map((item) => item.id);
    externalNotificationService.deactivateExternalNotifications(ids).then(()=>{
      gridApi.reload(dispatch, getState)();
    });
  }
};

api.removeExternalNotificationSettings = function(dispatch, getState) {
  return function (data) {
    let ids = data?.map(item => item.id)?.toJS() || [];

    let labels = createLabelHelper('mat.administration.userSettings.dialog.createExternalNotification.');
    let confirmationConfig = {
      message: labels.get('remove.confirmation.message', '', {count: ids?.length}),
      cancelHandler: messageDialogApi.close(dispatch, getState),
      submitHandler: () => api.doRemoveNotificationSettings(dispatch, getState)({ids}),
    };

    messageDialogApi.showConfirmation(dispatch, getState)(confirmationConfig);
  }
};

api.doRemoveNotificationSettings = function(dispatch, getState) {
  return function(data) {
    messageDialogApi.close(dispatch, getState)();

    externalNotificationService.removeExternalNotificationSettings(data).then((response) => {
      if (!Network.isResponseValid(response)) {
        console.error('Failed to remove external notification settings', response);
        messageDialogApi.responseError(dispatch, getState)(response);
        return {success: false};
      }
      gridApi.reload(dispatch, getState)();
    });
  }
};


/////////////////////////////////////////////////////////////////////////
// PRIVATE HELPERS
